import { getColor } from "./shared.js";
import { Text } from "@mantine/core";
import { jsx } from "react/jsx-runtime";

//#region src/components/typography/Body2.tsx
const Body2 = ({ children, bold = false, color = "gray", ta, highContrast = false, inline = false, "data-testid": testId, noWrap = false }) => /* @__PURE__ */ jsx(Text, {
	size: "sm",
	component: inline ? "span" : "p",
	fw: bold ? 600 : 400,
	ta,
	style: {
		color: getColor(color, highContrast),
		textWrap: noWrap ? "nowrap" : "wrap"
	},
	"data-testid": testId,
	children
});

//#endregion
export { Body2 };